export default __webpack_public_path__ + "static/media/usd.bba48499.svg";